// import { find, assign } from 'lodash'
export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      tools = _ref.tools;
  return {
    /**
     * @description 登录
     * @param {Object} data 登录携带的信息
     */
    loadUnitList: function loadUnitList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 接口请求
      return request({
        url: '/unit/list',
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
      });
    },
    saveUnit: function saveUnit(data) {
      return request({
        url: '/unit/save',
        method: 'post',
        data: data
      });
    }
  };
});